var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"v-letter-icon",style:(_vm.style)},[_c('span',{staticClass:"v-letter-icon__letter"},[_vm._v(_vm._s(_vm.letter()))])])}
var staticRenderFns = []

export { render, staticRenderFns }